module.exports = __webpack_public_path__ + "static/media/aboutImage2.58dbbcac.jpg";